export default __webpack_public_path__ + "static/media/wishlist.250c8b0e.svg";